<template>
    <reports-base
        page-size-changeable
        reportsName="mKasa"
        reportsTitle="Raport/ M/kasa"
        :conditionalDisplay="$store.getters.isMKasaDisplay"
        v-if="generateReports"
    >
        <template #slot-0>
            <div class="c-thead">
                <div class="c-tw">
                    <div class="c-td is-1">Okres</div>
                    <div class="c-td is-2">
                        Obrót ogółem
                        <a-icon
                            icon="Info"
                            v-tooltip="{
                                content:
                                    'Wartość brutto sprzedanych towarów<br/><i>Realizacja / Cel</i>'
                            }"
                            style="width: 18px; height: 18px"
                        />
                    </div>
                    <div class="c-td is-3">
                        Obrót piwo
                        <a-icon
                            icon="Info"
                            v-tooltip="{
                                content:
                                    'Wartość brutto sprzedanych towarów z kategorii piwo<br/><i>Realizacja / Cel</i>'
                            }"
                            style="width: 18px; height: 18px"
                        />
                    </div>
                    <div class="c-td is-4">
                        Sprzedaż na kodach EAN
                        <a-icon
                            icon="Info"
                            v-tooltip="{
                                content:
                                    'Stosunek sprzedaży z wykorzystaniem kodów EAN do ogólnej sprzedaży<br/><i>Realizacja / Cel</i>'
                            }"
                            style="width: 18px; height: 18px"
                        />
                    </div>
                </div>
            </div>
        </template>
        <template #slot-1>
            <div class="c-thead">
                <div class="c-tw">
                    <div class="c-td is-1">Okres</div>
                    <div class="c-td is-3">
                        Użyte promocje
                        <a-icon
                            icon="Info"
                            v-tooltip="{
                                content:
                                    'Liczba promocji użytych przynajmniej 1 raz'
                            }"
                            style="width: 18px; height: 18px"
                        />
                    </div>
                    <div class="c-td is-4">
                        Cel użytych promocji
                        <a-icon
                            icon="Info"
                            v-tooltip="{
                                content:
                                    'Liczba promocji, którą należy użyć, aby spełnić warunki porozumienia M/kasa'
                            }"
                            style="width: 18px; height: 18px"
                        />
                    </div>
                    <div class="c-td is-5"></div>
                </div>
            </div>
        </template>
    </reports-base>
</template>

<script>
import ReportsBase from '@/components/reports/ReportsBase'

export default {
    data() {
        return {
            generateReports: false
        }
    },
    components: {
        ReportsBase
    },
    created() {
        this.fetch()
    },
    methods: {
        async fetch() {
            await this.$store.dispatch('mKasaYearsFetch')
            this.generateReports = true
        }
    }
}
</script>
